import Crud from "../Crud";
import MUIBrownColor from "@mui/material/colors/brown";

/**
 * Static helper functions related to Accounts.
 */
export default class ActivityFileType extends Crud {

    /**
     * @param {object} activityFileType The activityFileType object.
     * @returns The display name of the activityFileType.
     */
    static getDisplayName(activityFileType) {
        return activityFileType.name;
    }

    /**
     * Determines if a activityFileType matches a search query.
     *
     * @param {object} activityFileType The activityFileType to test.
     * @param {string} query The search query.
     * @returns {boolean} Whether or not the activityFileType matches the query.
     */
    static match(activityFileType, query) {
        return (
            (activityFileType.name !== null && activityFileType.name.toLowerCase().includes(query)) ||
            activityFileType.id === +query
        );
    }

    /**
     * @param {array} activityFileTypes The list to sort.
     * @returns {array} The sorted list.
     */
    static sort(activityFileTypes) {
        return activityFileTypes.sort((a, b) => {
            return (a.name).localeCompare(b.name);
        });
    }

    /**
     * @returns {string} The color of this object.
     */
    static getBaseColor() {
        return MUIBrownColor;
    }

    /**
     * @returns {string} The icon name for this object.
     */
    static getIconName() {
        return "Article";
    }
}
